import type {InputTypes} from '../../../core/entities/reports/constants';

export const convertRadioTypeAnswer = (
  answer: string,
  input_type?: InputTypes,
) => {
  if (answer === '0' && input_type === 'radio') {
    return 'なし';
  }

  if (answer === '1' && input_type === 'radio') {
    return 'あり';
  }

  return answer;
};
